import { Button as ButtonAntd } from 'antd'
import { ButtonProps as ButtonAntdProps } from 'antd/es/button/button'

import { colors } from 'shared/constants/values'

interface ButtonProps extends ButtonAntdProps {
  newType?: 'warning'
}

export const Button = ({ children, type = 'primary', newType, style, disabled = false, ...props }: ButtonProps) => {
  const buttonColor = {
    ['warning']: colors.orange,
  }

  return (
    <ButtonAntd
      type={type}
      {...props}
      style={{ ...style, backgroundColor: newType && disabled === false ? buttonColor[newType] : undefined }}
      disabled={disabled}
    >
      {children}
    </ButtonAntd>
  )
}
